// Tour.tsx
import { Tour as AntdTour, TourProps as AntdTourProps, TourStepProps } from 'antd';
import React, { useState } from 'react';

const steps: TourStepProps[] = [
  {
    title: 'Step 1',
    description: 'This is the first step',
    target: () => document.querySelector('#step1') as HTMLElement || document.body,
  },
  {
    title: 'Step 2',
    description: 'This is the second step',
    target: () => document.querySelector('#step2') as HTMLElement || document.body,
  },
  // Add more steps as needed
];

const Tour: React.FC<AntdTourProps> = (props) => {
  const [open, setOpen] = useState(props.open);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <AntdTour steps={steps} open={open} onClose={handleClose} {...props} />
  );
};

export default Tour;